import React from 'react';
import { getProjectsByProfileId } from '@/services/projects';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import ProjectList from './ProjectList';
import { useAsyncState } from '@/utils/hooks';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import { getProfileModules } from '@/services/profiles';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { NoResultsCard } from '@/components/Cards';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight, faProjectDiagram } from '@fortawesome/pro-light-svg-icons';
import { LoadingIndicator, BygrModule } from '@ygtechnologies/bygr-frontend-component-library';

interface MyProjectsProps {
    profileId: number;
}

const MyProjects: React.FC<MyProjectsProps> = ({ profileId }) => {
    // const [projects] = useAsyncState(() => Promise.resolve([]), [profileId], null);
    const [projects, , reload] = useAsyncState(() => getProjectsByProfileId(profileId), [profileId], null);
    const [modules] = useAsyncState(() => getProfileModules(profileId), [profileId], null);
    const profile = useSelector((state: IState) => state.global.activeProfile);

    const canCreateProject = profile?.permissions.canCreateProject ?? false;

    function renderContent() {
        if (!projects) {
            return <LoadingIndicator />;
        }

        if (projects.length === 0) {
            if (!modules) {
                return <LoadingIndicator />;
            }

            if (modules?.some((x) => x.module === BygrModule.Aftermarket && x.projectCount > 0) && !canCreateProject) {
                return (
                    <NoResultsCard title={<Trans>You do not have any projects here...</Trans>} icon={faProjectDiagram}>
                        <div>
                            <Trans>However, you have projects available in the Aftermarket module</Trans>
                        </div>
                        <a href={`//${window.APP_CONFIG.AFTERMARKET_URL}`}>
                            <Trans>Go to Aftermarket</Trans> <FontAwesomeIcon icon={faLongArrowRight} />
                        </a>
                    </NoResultsCard>
                );
            }
        }

        if (projects.length === 0 && !canCreateProject) {
            return (
                <NoResultsCard title={<Trans>You have not been invited to any projects.</Trans>} icon={faProjectDiagram} />
            );
        }

        return (
            <ProjectList
                profileId={profileId}
                projects={projects}
                hrefGenerator={(project) => `/projects/${project.id}`}
                showCreateButton={canCreateProject}
                reloadProjects={() => reload()}
            />
        );
    }

    return (
        <div>
            <SimplePageTitle title={t`All projects`} />

            {renderContent()}
        </div>
    );
};

export default MyProjects;
